/**
 * @fileoverview Connect native numeric editing to shared form state through `utils.js`. The default `AppNumberInput` hands the parent a number or null directly; the PrimeReact-named `InputNumber` export instead sends `{ value, originalEvent, target }` to both `onChange` and `onValueChange` so migrated screens kept their handlers. The parent owns validation, units, and persistence.
 */

import React from 'react'
import { parseNumberInput } from './utils'

const inputStyle = {
    width: '100%',
    padding: '0.6rem 0.75rem',
    borderRadius: '6px',
    border: '1px solid var(--surface-border)',
    fontSize: '1rem',
    backgroundColor: 'var(--surface-section)',
    color: 'var(--text-color)'
}



function AppNumberInput({ id, value, onChange, step }) {
    const resolvedValue = value === null || value === undefined ? '' : value

    return (
        <input
            id={id}
            type="number"
            step={step}
            value={resolvedValue}
            onChange={(e) => onChange(parseNumberInput(e.target.value))}
            style={inputStyle}
        />
    )
}

export default AppNumberInput

export function InputNumber({ onChange, onValueChange, min, max, placeholder, disabled, showButtons, ...props }) {
  return <input {...props} type="number" min={min} max={max} placeholder={placeholder} disabled={disabled}
    value={props.value ?? ''} style={inputStyle} onChange={event => {
      const value = parseNumberInput(event.target.value);
      const change = { value, originalEvent: event, target: event.target };
      onChange?.(change); onValueChange?.(change);
    }} />;
}
